import { render } from "./FormMajorBank.vue?vue&type=template&id=4d3fe0bb&scoped=true"
import script from "./FormMajorBank.vue?vue&type=script&lang=js"
export * from "./FormMajorBank.vue?vue&type=script&lang=js"

import "./FormMajorBank.vue?vue&type=style&index=0&id=4d3fe0bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3fe0bb"]])

export default __exports__